import React, { useEffect, useState } from 'react'

import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import Dialog from '@material-ui/core/Dialog'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import html2canvas from 'html2canvas';
import NotoSansRegular from '../../assets/font/Noto_Sans/NotoSans-Regular-normal';
import NotoSansBold from '../../assets/font/Noto_Sans/NotoSans-Bold-normal';
import AppSettings from '../../webConfig';
import moment from 'moment'
import { Box } from '@material-ui/core'
import { CgClose } from 'react-icons/cg'
import { convertToCurrency, convertToCurrencyByKey, convertToString } from '../../assets/UtilMethods'
import { toast } from "react-toastify";
import ParameterConstants from '../../constants/ParameterConstants'

function EstateCurrentMarketValueForm(props) {

    const [showReport, setShowReport] = useState(false);

    useEffect(() => {
        let isReportOpen_ = props.isReportOpen;
        let reportData_ = props.reportData;

        if (isReportOpen_) {
            CreateEstateCurrentMarketValueForm(reportData_)
        }
    }, [])

    const CloseReport = () => {
        setShowReport(false);
        props.reportCallBack(false);
    }

    //ikinci rapor
    const CreateEstateCurrentMarketValueForm = async (reportData) => {
        try {
            let registry = props.registryInfo;
            let title = ""
            let identityOrTaxNumber = ""
            let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            let userNameAndSurname = userInfo.UserName;
            let isRetailRegistry = true;
            let placeOfBirth = ""
            let dateOfbirth = ""
            let fatherName = ""
            let relatedPerson = ""

            if (registry.RegistryType === "G") {
                title = registry.RegistryInfo.Name + " " + registry.RegistryInfo.SurName
                identityOrTaxNumber = registry.RegistryInfo.IdentityNumber
                placeOfBirth = registry.RegistryInfo.PlaceOfBirth
                dateOfbirth = registry.RegistryInfo.DateOfBirth
                fatherName = registry.RegistryInfo.FatherName
                isRetailRegistry = true
            } else if (registry.RegistryType === "Y") {
                title = registry.RegistryInfo.Name + " " + registry.RegistryInfo.Surname
                identityOrTaxNumber = registry.RegistryInfo.IdentityNumber
                placeOfBirth = registry.RegistryInfo.PlaceOfBirth
                dateOfbirth = registry.RegistryInfo.DateOfBirth
                fatherName = registry.RegistryInfo.FatherName
                isRetailRegistry = true
            } else {
                title = registry.RegistryInfo.Title
                identityOrTaxNumber = registry.RegistryInfo.TaxNumber
                relatedPerson = registry.RegistryInfo.RelatedPerson ? registry.RegistryInfo.RelatedPerson : ""
                isRetailRegistry = false;
            }

            setShowReport(true);
            var doc = new jsPDF();  //Rapor start fonksiyonu

            // Fontları jspdf içine entegre ediyoruz.
            var callAddFontRegular = function () {
                this.addFileToVFS('NotoSans-Regular-normal.ttf', NotoSansRegular);
                this.addFont('NotoSans-Regular-normal.ttf', 'NotoSans-Regular', 'normal');
            };
            jsPDF.API.events.push(['addFonts', callAddFontRegular])

            var callAddFontBold = function () {
                this.addFileToVFS('NotoSans-Bold-normal.ttf', NotoSansBold);
                this.addFont('NotoSans-Bold-normal.ttf', 'NotoSans-Bold', 'normal');
            };
            jsPDF.API.events.push(['addFonts', callAddFontBold])

            doc.setFont('NotoSans-Regular', 'normal'); // Rapordaki font'u belirler bütün textler aynı font olacaksa bir defa yazmak heterli her bir text farklı font olacaksa her text'ten önce yazılmalı.
            let pageWidth = doc.internal.pageSize.getWidth();  //Mevcut sayfanın genişliğini alıyor bunu yazıları ortalı koyabilmek için kullanacağız.
            let currentDate = moment(new Date()).format("DD.MM.YYYY HH:mm");
            //doc.autoTable({ html: '#table' })

            var img = new Image();
            img.src = ParameterConstants.URL_EXTENSION +"/assets/images/kurum_logo.png";
            if(AppSettings.LogoCoordinates){
                doc.addImage(img, 'png', AppSettings.LogoCoordinates.x, AppSettings.LogoCoordinates.y, AppSettings.LogoWidth, AppSettings.LogoHeight);
            }
            else{
                doc.addImage(img, 'png', 5, 3, 18, 18);
            }
           

            doc.setFont('NotoSans-Bold', 'normal');
            doc.setFontSize(12);
            doc.text(reportData.CurrentMarketValueReportParameter.TopTitleFirst !== null ? reportData.CurrentMarketValueReportParameter.TopTitleFirst : "", pageWidth / 2, 10, 'center');
            doc.text(reportData.CurrentMarketValueReportParameter.TopTitleSecond !== null ? reportData.CurrentMarketValueReportParameter.TopTitleSecond : "", pageWidth / 2, 15, 'center');
            doc.text(reportData.CurrentMarketValueReportParameter.TopTitleThird !== null ? reportData.CurrentMarketValueReportParameter.TopTitleThird : "", pageWidth / 2, 20, 'center');
            doc.text(reportData.CurrentMarketValueReportParameter.TopTitleFourth !== null ? reportData.CurrentMarketValueReportParameter.TopTitleFourth : "", pageWidth / 2, 20, 'center');

            doc.setFont('NotoSans-Regular', 'normal');
            doc.setFontSize(8); // Ve  Tarihi farklı bir fontSize da istiyorsam öncesinde fontSize belirtiyorum 
            doc.text("Tarih: " + currentDate, 180, 35, 'center'); //doc.text(text, X, Y, Align)

            doc.setFont('NotoSans-Bold', 'normal');
            doc.setFontSize(11);
            doc.text("Sayı:", 20, 35, 'left');
            doc.text("Konu:", 20, 40, 'left');

            doc.setFont('NotoSans-Regular', 'normal');
            doc.text(convertToString(reportData.ReportNumber), 40, 35, 'left');
            doc.text(reportData.CurrentMarketValueReportParameter.Subject, 40, 40, 'left');

            doc.setFont('NotoSans-Bold', 'normal');
            doc.setFontSize(12);
            doc.text(reportData.CurrentMarketValueReportParameter.TargetInstitution, pageWidth / 2, 50, 'center');  // Belediye adı dinamik gelecek ve ayrıca pageWidth ile yazıyı ortaladık.
            doc.text(reportData.CurrentMarketValueReportParameter.TargetCity.CityName, pageWidth / 2, 55, 'center');


            var lMargin = 25; //left margin in mm
            var rMargin = 20; //right margin in mm
            var pdfInMM = 210;  // width of A4 in mm

            doc.setFont('NotoSans-Regular', 'normal');
            doc.setFontSize(10);
            var rule1lines = doc.splitTextToSize(reportData.CurrentMarketValueReportParameter.BodyText, (pdfInMM - lMargin - rMargin));
            doc.text(lMargin, 68, rule1lines);


            doc.setFontSize(10);
            doc.text("Emlak D. No:", 20, 80, 'left');
            doc.text(convertToString(reportData.EstateDeclarationRegistry?.FileNumber), 50, 80, 'left');

            //let currentMarketValueReportParameter = reportData.CurrentMarketValueReportParameter;
            /*if (currentMarketValueReportParameter.UserDetail && currentMarketValueReportParameter.UserDetail?.Registry) {
                let registryUser = currentMarketValueReportParameter.UserDetail?.Registry?.RegistryInfo;

                doc.text(`${registryUser.Name} ${registryUser.SurName}`, 140, 100, 'left');
                doc.text(`${convertToString(currentMarketValueReportParameter?.UserDetail?.Title?.TitleName)}`, 140, 105, 'left');
            }*/


            if (isRetailRegistry) {
                doc.text("Kimlik No:", 20, 85, 'left');
                doc.text("Adı Soyadı:", 20, 90, 'left');
                doc.text("Doğum Yeri:", 20, 95, 'left');

                doc.text(identityOrTaxNumber, 50, 85, 'left');
                doc.text(title, 50, 90, 'left');
                doc.text(placeOfBirth, 50, 95, 'left');

                doc.text("Baba Adı:", 110, 80, 'left');
                doc.text("Doğum Tarihi:", 110, 85, 'left');

                doc.text(fatherName, 150, 80, 'left');
                doc.text(dateOfbirth, 150, 85, 'left');
            } else {
                doc.text("Vergi No:", 20, 85, 'left');
                doc.text("Ünvan:", 20, 90, 'left');
                doc.text("İlgil Kişi:", 20, 95, 'left');

                doc.text(identityOrTaxNumber, 50, 85, 'left');
                doc.text(title, 50, 90, 'left');
                doc.text(relatedPerson, 50, 95, 'left');
            }


            doc.text(convertToString(reportData.DeclarationYear) + " yılına ait emlak vergi değeridir.", 30, 110, 'left');


            let count = 1;
            let bodyData = [];
            let totalAmount = parseFloat(0);
            reportData.EstateDeclarationList.forEach(element => {
                let currentMarketValue = 0
                if (element.EstateDeclarationAccrumentDetail?.EstateDeclarationDetailList.find(x => x.TaxYear === reportData.DeclarationYear)) {
                    currentMarketValue = (element.EstateDeclarationAccrumentDetail.EstateDeclarationDetailList.find(x => x.TaxYear === reportData.DeclarationYear)).CurrentMarketValue
                }

                let data = {};
                data.Count = count++;
                data.DeclarationOrder = element.DeclarationOrder;
                data.District = element.Estate.AddressSource.DistrictName;
                data.Type = element.UsageType !== null ? element.UsageType.UsageTypeName : element.Estate.EstateType.TypeName;
                data.BlockOfBuildingsAndParcel = element.Estate.BlockOfBuildings + " / " + element.Estate.Parcel;
                data.BookAndPage = element.Estate.BookNo + " / " + element.Estate.PageNo;
                data.BlockNo = element.Estate.DetachedSectionNo + "/" + element.Estate.FloorNo + "/" + element.Estate.BlockNo;
                data.FieldArea = element.Estate.LandArea ? (element.Estate.LandArea.toFixed(2))?.replace(".", ",")?.replace(".", ",") : "";
                data.ShareHolderPortionAndDenominator = element.ShareHolderPortion + " / " + element.ShareHolderDenominator;
                data.LandPortion = element.Estate.LandPortion
                data.LandDenominator = element.Estate.LandDenominator
                data.SellingValue = convertToCurrency(currentMarketValue)
                totalAmount = totalAmount + parseFloat(currentMarketValue);
                //totalShareHolderArea = totalShareHolderArea + parseFloat(element.ShareHolderArea);


                //data.AccrumentAmount = this.props.CurrencyFormat(Number(element.AccrumentAmount).toFixed(2)).payload;

                bodyData.push(data);
            });
            //bodyData.push({ShareHolderPortionAndDenominator:"Toplam",ShareHolderArea:parseFloat(totalShareHolderArea).toFixed(2),DeclarationDebt:parseFloat(totalAmount),styles:{haling:'center',fillColor: [22, 160, 133]}}) 

            doc.autoTable({
                showHead: 'firstPage',  //Tablo header'larının sadece ilk sayfada görünmesini sağlar, her sayfada görünmesi isteniyorsa showHead:'everypage' yapmak yeterli
                margin: 5,
                tableLineColor: 0,
                tableLineWidth: 0.5,
                startY: 120, //Tablonun ilk sayfada nereden başlaması gerektiğini söyler
                body: bodyData, //hazırladığımız data buraya ekleniyor.
                columns: [ // Raporda tablo da hangi header'lar görünmeli belirleniyor.
                    {header: 'Beyan Sıra', dataKey: 'DeclarationOrder'},
                    {header: 'Mahalle', dataKey: 'District'},
                    {header: 'Cinsi', dataKey: 'Type'},
                    {header: 'Ada/Parsel', dataKey: 'BlockOfBuildingsAndParcel'},
                    {header: 'Tapu Cilt / Sayfa', dataKey: 'BookAndPage'},
                    {header: 'B.Bölüm/Kat/Blok No', dataKey: 'BlockNo'},
                    {header: 'M² si', dataKey: 'FieldArea'},
                    {header: 'Hisse Pay / Payda', dataKey: 'ShareHolderPortionAndDenominator'},
                    {header: 'Arsa Payı', dataKey: 'LandPortion'},
                    {header: 'Arsa Hissesi', dataKey: 'LandDenominator'},
                    {header: 'Rayiç Değeri', dataKey: 'SellingValue'},
                ],
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontWeight: 'bold',
                    fontSize: 6,
                    font: 'NotoSans-Bold',
                },
                styles: {
                    font: 'NotoSans-Regular',
                    lineWidth: 0.2,
                    lineColor: 0,
                    fontSize: 6,
                    textColor: 0,
                },

                columnStyles: {
                    0: {cellWidth: 'auto'},
                    1: {cellWidth: 'auto'},
                    2: {cellWidth: 'auto'},
                    3: {cellWidth: 'auto'},
                    4: {cellWidth: 'auto'},
                    5: {cellWidth: 'auto'},
                    6: {cellWidth: 'auto'},
                    7: {cellWidth: 'auto'},
                    8: {cellWidth: 'auto'},
                    9: {cellWidth: 'auto'},
                    10: {cellWidth: 'auto'},
                    11: {cellWidth: 'auto'},
                },


            })

            const pageCount = doc.internal.getNumberOfPages(); // Sayfa sonlarına pagination ekleme. burası değiştirilmeyecek sabit kalacak.
            doc.setFontSize(8)
            for (var i = 1; i <= pageCount; i++) {
                doc.setPage(i)
                doc.text('Sayfa ' + String(i) + ' / ' + String(pageCount), doc.internal.pageSize.width / 2, 294, {
                    align: 'center'
                })
            }


            let finalY = doc.lastAutoTable.finalY;
            doc.setFontSize(12)
            doc.setFont('NotoSans-Bold', 'normal');
            doc.setLineWidth(0.5);
            doc.setDrawColor(0, 0, 0, 1)
            doc.rect(5, finalY, 200, 6, 'D');
            doc.setFontSize(8)
            doc.text(`Toplam Emlak Vergi Değeri : ${convertToCurrency(totalAmount)}`, 140.5, finalY + 4);


            if (finalY >= 220) {
                doc.addPage();
                let finalSecondTableY = 0;

                doc.text(doc.splitTextToSize(reportData.CurrentMarketValueReportParameter.FootNoteFirst !== null ? reportData.CurrentMarketValueReportParameter.FootNoteFirst : "", 135), 10, finalSecondTableY + 20);
                doc.text(doc.splitTextToSize(reportData.CurrentMarketValueReportParameter.FootNoteSecond !== null ? reportData.CurrentMarketValueReportParameter.FootNoteSecond : "", 135), 10, finalSecondTableY + 30);
                doc.text(doc.splitTextToSize(reportData.CurrentMarketValueReportParameter.FootNoteThird !== null ? reportData.CurrentMarketValueReportParameter.FootNoteThird : "", 135), 10, finalSecondTableY + 40);
                doc.text(doc.splitTextToSize(reportData.CurrentMarketValueReportParameter.FootNoteFourth !== null ? reportData.CurrentMarketValueReportParameter.FootNoteFourth : "", 135), 10, finalSecondTableY + 50);

                doc.text(doc.splitTextToSize(props.concurrenceInfo ? `Müşterek/El Birliği: ${props.concurrenceInfo}` : "", 140), 20, finalSecondTableY + 55, 'left');
                //doc.text(props.concurrenceInfo ? `Müşterek/El Birliği: ${props.concurrenceInfo}` : "", 20, finalY + 55, 'left');	
                if (props.concurrenceInfo) {
                    doc.setFont('NotoSans-Regular', 'normal');
                    doc.text("DÜZENLEYEN", 20, finalSecondTableY + 100, 'left');
                    doc.text(userNameAndSurname, 20, finalSecondTableY + 105, 'left');

                    doc.text(moment().format("DD.MM.YYYY"), 170, finalSecondTableY + 100, 'left');
                } else {
                    doc.setFont('NotoSans-Regular', 'normal');
                    doc.text("DÜZENLEYEN", 20, finalSecondTableY + 60, 'left');
                    doc.text(userNameAndSurname, 20, finalSecondTableY + 65, 'left');

                    doc.text(moment().format("DD.MM.YYYY"), 170, finalSecondTableY + 60, 'left');
                }

            } else {
                doc.text(doc.splitTextToSize(reportData.CurrentMarketValueReportParameter.FootNoteFirst !== null ? reportData.CurrentMarketValueReportParameter.FootNoteFirst : "", 135), 10, finalY + 20);
                doc.text(doc.splitTextToSize(reportData.CurrentMarketValueReportParameter.FootNoteSecond !== null ? reportData.CurrentMarketValueReportParameter.FootNoteSecond : "", 135), 10, finalY + 30);
                doc.text(doc.splitTextToSize(reportData.CurrentMarketValueReportParameter.FootNoteThird !== null ? reportData.CurrentMarketValueReportParameter.FootNoteThird : "", 135), 10, finalY + 40);
                doc.text(doc.splitTextToSize(reportData.CurrentMarketValueReportParameter.FootNoteFourth !== null ? reportData.CurrentMarketValueReportParameter.FootNoteFourth : "", 135), 10, finalY + 50);

                doc.text(doc.splitTextToSize(props.concurrenceInfo ? `Müşterek/El Birliği: ${props.concurrenceInfo}` : "", 140), 20, finalY + 55, 'left');
                //doc.text(props.concurrenceInfo ? `Müşterek/El Birliği: ${props.concurrenceInfo}` : "", 20, finalY + 55, 'left');	
                if (props.concurrenceInfo) {
                    doc.setFont('NotoSans-Regular', 'normal');
                    doc.text("DÜZENLEYEN", 20, finalY + 100, 'left');
                    doc.text(userNameAndSurname, 20, finalY + 105, 'left');

                    doc.text(moment().format("DD.MM.YYYY"), 170, finalY + 100, 'left');
                } else {
                    doc.setFont('NotoSans-Regular', 'normal');
                    doc.text("DÜZENLEYEN", 20, finalY + 60, 'left');
                    doc.text(userNameAndSurname, 20, finalY + 65, 'left');

                    doc.text(moment().format("DD.MM.YYYY"), 170, finalY + 60, 'left');
                }
            }

            html2canvas(document.body, {scale: 2, scrollY: 0, height: window.outerHeight + window.innerHeight, windowHeight: window.outerHeight + window.innerHeight,}).then(canvas => {

                let output = doc.output('bloburl');
                document.getElementById("pdfObj").height = canvas.height / 4;
                document.getElementById("pdfObj").data = output;
            });
        } catch (e) {
            CloseReport()
            toast.warning(e.message);
            return;
        }

    }


    return (
        <div style={{width: '54vw', overflowX: 'hidden',}}>
            <Dialog maxWidth="lg"
                    onClose={() => CloseReport()}
                //aria-labelledby="customized-dialog-title"
                    open={showReport}
            >
                <DialogTitle>
                    <Box display="flex" alignItems="center">
                        <Box flexGrow={1}><Typography>Rapor</Typography></Box>
                        <Box>
                            <IconButton onClick={() => CloseReport()}>
                                <CgClose style={{color: "#000"}}/>
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers style={{height: '40vw', width: '54vw', overflowX: 'hidden'}}>
                    <div style={{overflowX: 'hidden',}}>
                        <center style={{width: '54vw', height: 'auto'}}>
                            <object id="pdfObj" data="" type="application/pdf" width="90%">

                            </object>
                        </center>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default EstateCurrentMarketValueForm

